module.exports = __webpack_public_path__ + "img/meme_05.c353f137.jpg";